
  import { defineComponent } from "vue";

  export default defineComponent({
    name: "CardDescription",

    props: {
      source: {
        type: String,
        required: true,
        default: () => "-",
      },
    },
  });
